import { useFundsStore } from 'features/Funds/infra/react/Funds.state'

export const useFundsActions = () =>
  useFundsStore(store => ({
    getFundsInfo: store.actions.getFundsInfo.execute,
  }))
